var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlerts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Navigation, Property 2=Notifications"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2427 1.30921C16.8277 1.91289 19.4522 5.01518 19.448 8.6487V14.6715C19.4479 15.812 19.6847 16.9409 20.1446 17.9993L20.3275 18.3915L20.9416 19.6187C21.0875 19.9102 20.9694 20.2649 20.6778 20.4108C20.5958 20.4518 20.5054 20.4732 20.4136 20.4732H3.5862C3.26016 20.4732 2.99585 20.2089 2.99585 19.8829C2.99585 19.791 3.01727 19.7005 3.0584 19.6184L3.67316 18.3915C4.24924 17.2349 4.54986 15.9615 4.54986 14.6702V8.64743C4.53727 5.01009 7.16875 1.90146 10.7608 1.30921C11.5806 1.16646 12.4228 1.16646 13.2427 1.30921ZM12.951 2.98401C12.3242 2.87486 11.6793 2.87486 11.0374 2.98657C8.34721 3.43011 6.35664 5.70373 6.25398 8.40775L6.24986 8.64743V14.6702C6.24986 15.9649 5.99892 17.2452 5.51281 18.444L5.37099 18.7731H18.63L18.5855 18.6768C18.0879 17.5317 17.8075 16.316 17.7565 15.083L17.748 14.6715L17.748 8.64673C17.7512 5.925 15.8413 3.58863 13.1957 3.03023L12.951 2.98401ZM12 22.9026C11.0463 22.9026 10.2731 22.1294 10.2731 21.1757H13.7268C13.7268 22.1294 12.9537 22.9026 12 22.9026Z",
    fill: "#006CB7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.7a20f6255b84574876d78e9abc5641a5.svg";
export { ForwardRef as ReactComponent };